var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dropRef",staticClass:"w-100 position-relative"},[_vm._t("default",null,{"result":_vm.result},{ open: _vm.open, reset: _vm.reset })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }